import { useState } from 'react';
import { useClientModal } from '@shared/clientModalContext';
import ClientFormModal from '../components/ClientFormModal';
import PartsNeededFormModal from '../components/PartsNeededFormModal';
import { ShellProvider } from './ShellContext';
import CommandBar from './CommandBar';
import StatusBar from './StatusBar';
import CommandPalette from './CommandPalette';
import AssistantPanel from '../features/assistant/AssistantPanel';
import MessagePanel from '../features/messaging/MessagePanel';
import { TutorialProvider } from '../features/tutorial/TutorialContext';
import TutorialOverlay from '../features/tutorial/TutorialOverlay';
import TutorialHub from '../features/tutorial/TutorialHub';

export default function AppShell({ children }) {
  const [isPartsModalOpen, setIsPartsModalOpen] = useState(false);
  const { isOpen, client, mode, closeModal } = useClientModal();

  return (
    <ShellProvider>
      <TutorialProvider>
        <div className="hub-shell">
          <CommandBar onOpenPartsModal={() => setIsPartsModalOpen(true)} />
          <main className="hub-workspace">
            {children}
          </main>
          <StatusBar />
          <CommandPalette />
          <AssistantPanel />
          <MessagePanel />
          <TutorialOverlay />
          <TutorialHub />
        </div>

        <ClientFormModal
          client={client}
          isOpen={isOpen}
          onClose={closeModal}
          mode={mode}
        />

        <PartsNeededFormModal
          isOpen={isPartsModalOpen}
          onClose={() => setIsPartsModalOpen(false)}
          mode="create"
          part={null}
        />
      </TutorialProvider>
    </ShellProvider>
  );
}
